import React from 'react'
import { useRoutes } from 'react-router-dom'
import LandingPage from '../pages/landingPage/LandingPage'
import Main from '../layout/Main'
import Dashboard from '../pages/dashboard/Dashboard'
import Companies from '../pages/dashboard/companies/Companies'
import Login from '../pages/auth/login/Login'
import Logout from '../pages/auth/Logout'
import SignUp from '../pages/auth/SignUp'
import Settings from '../pages/settings/Settings'
import BusinessSettings from '../pages/settings/BusinessSettings'
import AdminCreateVoucher from '../pages/dashboard/admin/AdminCreateVoucher'
import UsersPage from '../pages/admin/users/UsersPage'
import RolesPage from '../pages/admin/roles/RolesPage'
import Members from '../pages/dashboard/members/Members'
import Locations from '../pages/dashboard/locations/Locations'
import Facilities from '../pages/dashboard/facilities/Facilities'
import Addons from '../pages/dashboard/addons/Addons'
import Voucher from '../pages/dashboard/ledgers/vouchers/Voucher'
import Ledgers from '../pages/dashboard/ledgers/Ledgers'
import Packages from '../pages/dashboard/packages/Packages'
import PersonalTrainer from '../pages/dashboard/personalTrainers/PersonalTrainers'
import Assets from '../pages/dashboard/assets/Assets'
import StaffMember from '../pages/dashboard/staff/StaffMember'
import ProfileMember from '../pages/dashboard/profilemember/ProfileMember'
import VouchersTable from '../pages/dashboard/ledgers/vouchers/VouchersTable'
import Transaction from '../pages/dashboard/ledgers/transactions/Transactions'
import Recipt from '../pages/dashboard/ledgers/receipts/Receipts'
import Receipts from '../pages/dashboard/ledgers/receipts/Receipts'
import Visitor from '../pages/dashboard/visitor/Visitor'
import MemberAttendance from '../pages/dashboard/attendance/MemberAttendance'
import MemberHistory from '../pages/dashboard/attendance/MemberHistory'
import StaffAttendance from '../pages/dashboard/attendance/StaffAttendance'
import StaffHistory from '../pages/dashboard/attendance/StaffHistory'
import StaffProfile from '../pages/dashboard/profilemember/StaffProfile'
import CompanyLedgers from '../pages/dashboard/comapnyLedgers/CompanyLedgers'
import FeeCollectionReport from '../pages/dashboard/reports/fee_collection_report/FeeCollectionReport'
import InvoiceReport from '../pages/dashboard/reports/invoices/InvoiceReport'
import ExpectedIncomeReport from '../pages/dashboard/reports/expected_income_report/ExpectedIncomeReport'
import Expense from "../pages/dashboard/expense/Expense"
import ChangePassword from '../pages/auth/change-password/changePassword'
import POS from '../pages/dashboard/pos/POS'
import POSInvoiceView from '../pages/dashboard/pos/POSInvoiceView'
import MemberStatusAudit from '../pages/dashboard/reports/member_reports/MemberStatusAudit'
import IncomeBreakdownReport from '../pages/dashboard/reports/income_breakdown_report/IncomeBreakdownReport'
import MemberTrainerLogReport from '../pages/dashboard/reports/member_trainer_log_report/MemberTrainerLogReport'
import MembershipAnalysisReport from '../pages/dashboard/reports/membership_analysis_report/MembershipAnalysisReport'
import PersonalCoachingAnalysisReport from '../pages/dashboard/reports/personal_coaching_analysis_report/PersonalCoachingAnalysisReport'
import MemberLogin from '../pages/member/auth/MemberLogin'
import MemberDashboard from '../pages/member/MemberDashboard'
import MemberInvoices from '../pages/member/MemberInvoices'
import MemberInvoiceView from '../pages/member/MemberInvoiceView'
import MemberPaymentResult from '../pages/member/MemberPaymentResult'
import MemberProfile from '../pages/member/MemberProfile'

function Router() {
    const routes = [
        {
            path: "/",
            element: <LandingPage/>,
        },
        {
            path: 'login',
            element: <Login/>
        },
        {
            path: 'member/login',
            element: <MemberLogin/>
        },
        {
            path: 'logout',
            element: <Logout/>
        },
        {
            path: 'signup',
            element: <SignUp/>
        },
        {
            path: 'change-password',
            element: <ChangePassword/>
        },
        {
            path: '/',
            element: <Main/>,
            children: [
                {
                    path: 'dashboard',
                    element: <Dashboard/>
                },
                {
                    path: 'member/dashboard',
                    element: <MemberDashboard/>
                },
                {
                    path: 'member/invoices',
                    element: <MemberInvoices/>
                },
                {
                    path: 'member/invoices/:invoiceId',
                    element: <MemberInvoiceView/>
                },
                {
                    path: 'member/payments/result',
                    element: <MemberPaymentResult/>
                },
                {
                    path: 'member/profile',
                    element: <MemberProfile/>
                },
                {
                    path: 'companies',
                    element: <Companies/>
                },
                {
                    path: 'packages',
                    element: <Packages/>
                },
                {
                    path: 'vouchers/:id',
                    element: <VouchersTable/>
                },
                {
                    path: 'voucher/:id',
                    element: <Voucher/>
                },
                {
                    path: 'transactions',
                    element: <Transaction/>
                },
                {
                    path: 'company-ledgers',
                    element: <CompanyLedgers/>
                },
                {
                    path: 'fee-collection-report',
                    element: <FeeCollectionReport/>
                },
                {
                    path: 'invoice-report',
                    element: <InvoiceReport/>
                },
                {
                    path: 'expected-income/:income',
                    element: <ExpectedIncomeReport/>
                }, 
                // {
                //     path: 'transaction/:id',
                //     element: <Transaction/>
                // },
                {
                    path: 'ledgers',
                    element: <Ledgers/>
                },
                {
                    path: 'members',
                    element: <Members/>
                },
                {
                    path: 'settings',
                    element: <Settings/>
                },
                {
                    path: 'business-settings',
                    element: <BusinessSettings/>
                },
                {
                    path: 'admin/vouchers/create',
                    element: <AdminCreateVoucher/>
                },
                {
                    path: 'admin/users',
                    element: <UsersPage/>
                },
                {
                    path: 'admin/roles',
                    element: <RolesPage/>
                },
                {
                    path: 'locations',
                    element: <Locations/>
                },
                {
                    path: 'facilities',
                    element: <Facilities/>
                },
                {
                    path: 'addons',
                    element: <Addons/>
                },
                {
                    path: 'trainers',
                    element: <PersonalTrainer/>
                },
                {
                    path: 'assets',
                    element: <Assets/>
                },
                {
                    path: 'staffmember',
                    element: <StaffMember/>
                },
                {
                    path: '/profilemember',
                    element: <ProfileMember/>
                },
                {
                    path: '/staffprofile/:staff_id',
                    element: <StaffProfile/>
                },
                {
                    path: '/recipt/:id',
                    element: <Receipts/>
                },
                {
                    path: '/visitor',
                    element: <Visitor/>
                },
                {
                    path: '/memberattendance',
                    element: <MemberAttendance/>
                },
                {
                    path: '/memberhistory/:member_id',
                    element: <MemberHistory/>
                },
                {
                    path: '/staffhistory/:staff_id',
                    element: <StaffHistory/>
                },
                {
                    path: '/staffattendance',
                    element: <StaffAttendance/>
                },
                {
                    path: '/expense',
                    element: <Expense/>
                },
                {
                    path: '/pos',
                    element: <POS/>
                },
                {
                    path: '/pos-invoice/:id',
                    element: <POSInvoiceView/>
                },
                {
                    path: '/member-status-audit',
                    element: <MemberStatusAudit/>
                },
                {
                    path: '/income-breakdown-report',
                    element: <IncomeBreakdownReport/>
                },
                {
                    path: '/member-trainer-log-report',
                    element: <MemberTrainerLogReport/>
                },
                {
                    path: '/membership-analysis-report',
                    element: <MembershipAnalysisReport/>
                },
                {
                    path: '/personal-coaching-analysis-report',
                    element: <PersonalCoachingAnalysisReport/>
                },
            ]
        }
    ]

  return(
    useRoutes(routes)
  ) 
}

export default Router